var scorm2004Obj = (function () {
    "use strict";

    var api, dmeList, utilsInstance, scorm2004Obj = {};

    scorm2004Obj.getRuntimeData = function() {
        return dmeList;
    };

    scorm2004Obj.set = function(key, value) {
        api.SetValue(key, value);
    };

    scorm2004Obj.commit = function() {
        api.Commit("");
    };

    scorm2004Obj.finish = function() {
        api.Commit("");
        api.Terminate("");
        // TODO Should we do this?  Maybe this should be a custom option?
        document.location.href = "blank.htm";
    };

    scorm2004Obj.loadDataFromLMS = function () {
        var n, ret, qArray, w, h, i, parsed, lic = '', scoUrl = '';
        api = getAPIHandle();

        if (!api) {
            alert("LMS API Adapter for SCORM 2004 could not be located. There is no communication with the LMS therefor no content will be fetched from the content server.");
            return;
        }

        n = api.Initialize("");
        if (n !== "true") {
            alert("LMS Initialize failed.");
            return;
        }
        dmeList = {};
        dmeList["cmi._version"] = "";
        dmeList["cmi._children"] = "";
        dmeList["cmi.learner_id"] = "";
        dmeList["cmi.learner_name"] = "";
        dmeList["cmi.location"] = "";
        dmeList["cmi.credit"] = "";
        dmeList["cmi.completion_status"] = "";
        dmeList["cmi.completion_threshold"] = "";
        dmeList["cmi.success_status"] = "";
        dmeList["cmi.entry"] = "";
        dmeList["cmi.total_time"] = "";
        dmeList["cmi.mode"] = "";

        dmeList["cmi.suspend_data"] = "";
        dmeList["cmi.launch_data"] = "";
        dmeList["cmi.progress_measure"] = "";

        dmeList["cmi.scaled_passing_score"] = "";
        //score
        dmeList["cmi.score._children"] = "";
        dmeList["cmi.score.scaled"] = "";
        dmeList["cmi.score.raw"] = "";
        dmeList["cmi.score.min"] = "";
        dmeList["cmi.score.max"] = "";

        //student data
        dmeList["cmi.max_time_allowed"] = "";
        dmeList["cmi.time_limit_action"] = "";
        dmeList["cmi.learner_preference._children"] = "";
        dmeList["cmi.learner_preference.audio_captioning"] = "";
        dmeList["cmi.learner_preference.delivery_speed"] = "";
        dmeList["cmi.learner_preference.language"] = "";
        dmeList["cmi.learner_preference.audio_level"] = "";

        //student preference
        dmeList["cmi.student_preference._children"] = "";
        dmeList["cmi.student_preference.audio"] = "";
        dmeList["cmi.student_preference.language"] = "";
        dmeList["cmi.student_preference.speed"] = "";
        dmeList["cmi.student_preference.text"] = "";

        //objectives
        dmeList["cmi.objectives._children"] = "";
        dmeList["cmi.objectives._count"] = "";

        //interactions
        dmeList["cmi.interactions._children"] = "";
        dmeList["cmi.interactions._count"] = "";

        //comments from LMS
        dmeList["cmi.comments_from_lms._children"] = "";
        dmeList["cmi.comments_from_lms._count"] = "";

        //comments from Learner
        dmeList["cmi.comments_from_learner._children"] = "";
        dmeList["cmi.comments_from_learner._count"] = "";

        for (i in dmeList) {
            ret = api.GetValue(i);
            dmeList[i] = ret;
        }
        dmeList.objectives = [];
        dmeList.interactions = [];
        dmeList.commentsFromLearner = [];
        dmeList.commentsFromLMS = [];
        scorm2004Obj.getObjectiveData();
        scorm2004Obj.getInteractionData();
        scorm2004Obj.getCommentsFromLearner();
        scorm2004Obj.getCommentsFromLMS();
        scorm2004Obj.setupDefaults();
    };

    scorm2004Obj.setupDefaults = function () {
        if (s4xdmConfig.forceStatusIncompleteOnInit) {
            var cs = dmeList["cmi.completion_status"];
            if (!cs || cs === "not attempted" || cs === "unknown") {
                dmeList["cmi.completion_status"] = "incomplete";
                api.LMSSetValue("cmi.completion_status", "incomplete");
            }
        }
    };

    scorm2004Obj.getObjectiveData = function () {
        if (!s4xdmConfig.useObjectives) {
            return;
        }
        var i = -1, j, ret, obj_names = [];
        obj_names[0] = "id";
        obj_names[1] = "score._children";
        obj_names[2] = "score.raw";
        obj_names[3] = "score.scaled";
        obj_names[4] = "score.min";
        obj_names[5] = "score.max";
        obj_names[6] = "success_status";
        obj_names[7] = "completion_status";
        obj_names[8] = "progress_measure";
        obj_names[9] = "description";
        var _nameCount = "cmi.objectives._count";
        var nCount = parseInt(api.GetValue(_nameCount));

        var _name = "";
        var _value = "";
        if (!isNaN(nCount)) {
            for (i = nCount - 1; i >= 0; i--) { //walk backward in case LMS does journaling
                for (j = 0; j < obj_names.length; j++) {
                    _name = "cmi.objectives." + i + "." + obj_names[j];
                    _value = api.GetValue(_name);
                    dmeList[_name] = _value;
                }
            }
            //add the _count
            dmeList[_nameCount] = nCount;
        }
        else {
            //add the _count
            dmeList[_nameCount] = "0";
        }

    };

    scorm2004Obj.getInteractionData = function () {
        if (!s4xdmConfig.useInteractions) {
            return;
        }
        var i = -1, j, ret, interaction_names = [];
        var _name = "";
        var _value = "";
        interaction_names[0] = "objectives._count";
        interaction_names[1] = "correct_responses._count";
        interaction_names[2] = "id";
        interaction_names[3] = "type";
        interaction_names[4] = "objectives";
        interaction_names[5] = "timestamp";
        interaction_names[6] = "correct_responses";
        interaction_names[7] = "weighting";
        interaction_names[8] = "learner_response";
        interaction_names[9] = "result";
        interaction_names[10] = "latency";
        interaction_names[11] = "description";

        var _nameCount = "cmi.interactions._count";
        var nCount = parseInt(api.GetValue(_nameCount));
        if (!isNaN(nCount)) {
            for (i = nCount - 1; i >= 0; i--) { //walk backward in case LMS does journaling
                for (j = 0; j < interaction_names.length; j++) {
                    _name = "cmi.interactions." + i + "." + interaction_names[j];
                    _value = api.GetValue(_name);
                    dmeList[_name] = _value
                }
            }
            //add the _count
            dmeList[_nameCount] = nCount;
        }
        else {
            //add the _count
            dmeList[_nameCount] = "0";
        }
    };

    scorm2004Obj.getCommentsFromLearner = function () {
        if (!s4xdmConfig.useCommentsFromLearner) {
            return;
        }
        var i = -1, j, ret, obj_names = [];
        obj_names[0] = "comment";
        obj_names[1] = "location";
        obj_names[2] = "timestamp";
        var _nameCount = "cmi.comments_from_learner._count";
        var nCount = parseInt(api.GetValue(_nameCount));

        var _name = "";
        var _value = "";
        if (!isNaN(nCount)) {
            for (i = nCount - 1; i >= 0; i--) { //walk backward in case LMS does journaling
                for (j = 0; j < obj_names.length; j++) {
                    _name = "cmi.comments_from_learner." + i + "." + obj_names[j];
                    _value = api.GetValue(_name);
                    dmeList[_name] = _value;
                }
            }
            //add the _count
            dmeList[_nameCount] = nCount;
        }
        else {
            //add the _count
            dmeList[_nameCount] = "0";
        }

    };

    scorm2004Obj.getCommentsFromLMS = function () {
        if (!s4xdmConfig.useCommentsFromLMS) {
            return;
        }
        var i = -1, j, ret, obj_names = [];
        obj_names[0] = "comment";
        obj_names[1] = "location";
        obj_names[2] = "timestamp";
        var _nameCount = "cmi.comments_from_lms._count";
        var nCount = parseInt(api.GetValue(_nameCount));

        var _name = "";
        var _value = "";
        if (!isNaN(nCount)) {
            for (i = nCount - 1; i >= 0; i--) { //walk backward in case LMS does journaling
                for (j = 0; j < obj_names.length; j++) {
                    _name = "cmi.comments_from_lms." + i + "." + obj_names[j];
                    _value = api.GetValue(_name);
                    dmeList[_name] = _value;
                }
            }
            //add the _count
            dmeList[_nameCount] = nCount;
        }
        else {
            //add the _count
            dmeList[_nameCount] = "0";
        }

    };

// local variable definitions
    var apiHandle = null;
    var API = null;
    var findAPITries = 0;

    /******************************************************************************
     **
     ** Function getAPIHandle()
     ** Inputs:  None
     ** Return:  value contained by APIHandle
     **
     ** Description:
     ** Returns the handle to API object if it was previously set,
     ** otherwise it returns null
     **
     *******************************************************************************/
    function getAPIHandle() {
        if (apiHandle == null) {
            apiHandle = getAPI();
        }

        return apiHandle;
    }

    /*******************************************************************************
     **
     ** Function findAPI(win)
     ** Inputs:  win - a Window Object
     ** Return:  If an API object is found, it's returned, otherwise null is returned
     **
     ** Description:
     ** This function looks for an object named API in parent and opener windows
     **
     *******************************************************************************/
    function findAPI(win) {
        while ((win.API_1484_11 == null) && (win.parent != null) && (win.parent != win)) {
            findAPITries++;

            if (findAPITries > 500) {
                alert("Error finding API -- too deeply nested.");
                return null;
            }

            win = win.parent;

        }
        return win.API_1484_11;
    }

//created by Mike Rustici
    var MAX_PARENTS_TO_SEARCH = 500;
    /*
     ScanParentsForApi
     -Searches all the parents of a given window until
     it finds an object named "API_1484_11". If an
     object of that name is found, a reference to it
     is returned. Otherwise, this function returns null.
     */
    function ScanParentsForApi(win) {
        /*
         Establish an outrageously high maximum number of
         parent windows that we are will to search as a
         safe guard against an infinite loop. This is
         probably not strictly necessary, but different
         browsers can do funny things with undefined objects.
         */
        var nParentsSearched = 0;
        /*
         Search each parent window until we either:
         -find the API,
         -encounter a window with no parent (parent is null
         or the same as the current window)
         -or, have reached our maximum nesting threshold
         */
        while ((win.API_1484_11 == null) &&
        (win.parent != null) && (win.parent != win) &&
        (nParentsSearched <= MAX_PARENTS_TO_SEARCH)
            ) {
            nParentsSearched++;
            win = win.parent;
        }
        /*
         If the API doesn't exist in the window we stopped looping on,
         then this will return null.
         */
        return win.API_1484_11;
    }

    /*
     GetAPI
     -Searches all parent and opener windows relative to the
     current window for the SCORM 2004 API Adapter.
     Returns a reference to the API Adapter if found or null
     otherwise.
     */
    function getAPI() {
        var API = null;

        //Search all the parents of the current window if there are any
        if ((window.parent != null) && (window.parent != window)) {
            API = ScanParentsForApi(window.parent);
        }
        /*
         If we didn't find the API in this window's chain of parents,

         then search all the parents of the opener window if there is one

         */
        if ((API == null) && (window.top.opener != null)) {
            API = ScanParentsForApi(window.top.opener);
        }
        return API;
    }

    return scorm2004Obj;
})();
